// src/services/api.js
import axios from 'axios';

export const apiClient = axios.create({
  baseURL: 'https://points.hatchup.ru/api', // Этот URL используется только для локальной разработки, на проде он не важен
});

// Перехватчик ЗАПРОСОВ (остается без изменений)
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('hatchup_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// --- НОВОЕ: Перехватчик ОТВЕТОВ ---
// Эта функция будет срабатывать после КАЖДОГО ответа от сервера
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('hatchup_token');

    // Проверяем, есть ли уже заголовок Authorization (в любом регистре)
    const hasAuth = config.headers['Authorization'] || config.headers['authorization'];

    if (token && !hasAuth) {
      // Добавляем только если заголовка НЕТ
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    
    // Для отладки: раскомментируйте строку ниже, чтобы видеть заголовки в консоли
    // console.log('Final Headers for', config.url, ':', config.headers);

    return config;
  },
  (error) => Promise.reject(error)
);



// Экспортируем функции для каждого эндпоинта
export const getProfileData = (params) => {
  return apiClient.get('/me', { params: params }); // <-- ИЗМЕНЕНИЕ
};

export const getLeaderboard = () => {
  return apiClient.get('/leaderboard');
};
export const getAllUsers = () => {
  return apiClient.get('/users');
};

export const grantPoints = (data) => {
  // data = { recipientId, points, category, reason }
  return apiClient.post('/points/grant', data);
};
export const getSeasons = () => {
  return apiClient.get('/seasons');
};

export const createSeason = (data) => {
  // data = { name, startDate, endDate }
  return apiClient.post('/seasons', data);
};

export const startSeason = (seasonId) => {
  return apiClient.post(`/seasons/${seasonId}/start`);
};
export const endSeason = (seasonId) => {
  return apiClient.post(`/seasons/${seasonId}/end`);
};
export const getArchivedSeasons = () => {
  return apiClient.get('/seasons/archived');
};
export const deletePointEntry = (entryId) => {
  return apiClient.delete(`/points/entry/${entryId}`);
};
export const deleteSeason = (seasonId) => {
  return apiClient.delete(`/seasons/${seasonId}`);
};
export const getGlobalHistory = (params) => {
  return apiClient.get('/history/global', { params }); // <-- Добавляем { params }
};
export const getCategories = () => {
  return apiClient.get('/points/categories');
};
export const getVapidKey = () => {
  return apiClient.get('/notifications/vapid-key');
};
export const unsubscribeFromPush = (subscription) => {
  return apiClient.delete('/notifications/unsubscribe', {
    data: { endpoint: subscription.endpoint }, // В DELETE-запросах Axios тело передается через `data`
  });
};
export const linkEmailPassword = (data) => {
  return apiClient.post('/auth/link-email', data);
};

export const loginWithEmail = (data) => {
  return apiClient.post('/auth/login-email', data);
};
export const transferPoints = (data) => {
  // data = { recipientId, amount }
  return apiClient.post('/points/transfer', data);
};
export const claimDailyReward = () => {
  return apiClient.post('/rewards/claim');
};
export const getShopItems = () => {
  return apiClient.get('/shop/items');
};

export const purchaseShopItem = (itemId) => {
  return apiClient.post('/shop/purchase', { itemId });
};
export const getPromoCodes = () => {
  return apiClient.get('/promocodes');
};

export const createPromoCode = (data) => {
  // data = { code, points, expiresAt, usesLeft }
  return apiClient.post('/promocodes', data);
};

export const deletePromoCode = (codeId) => {
  return apiClient.delete(`/promocodes/${codeId}`);
};

export const activatePromoCode = (code) => {
  return apiClient.post('/promocodes/activate', { code });
};
export const getInventory = () => {
  return apiClient.get('/inventory');
};

export const activateInventoryItem = (inventoryItemId) => {
  return apiClient.post('/inventory/activate', { inventoryItemId });
};
export const activateRoleItem = (data) => {
  // data = { inventoryItemId, roleName, roleColor }
  return apiClient.post('/roles/activate', data);
};
export const extendActiveRole = (inventoryItemId) => {
  return apiClient.post('/roles/extend', { inventoryItemId });
};
export const adminGrantItem = (data) => { return apiClient.post('/admin/grant-item', data); };
// --- Функции для XP ---
export const getMyXpStats = () => {
  return apiClient.get('/xp/me');
};

export const getXpLeaderboard = (page = 1, sortBy = 'totalXp') => {
  return apiClient.get('/xp/leaderboard', { params: { page, sortBy } });
};

export const spinShopRoulette = () => {
  return apiClient.post('/shop/spin-roulette');
};
export const deleteInventoryItem = (itemId) => {
  return apiClient.delete(`/inventory/${itemId}`);
};

export const transferInventoryItem = (itemId, recipientId) => {
  return apiClient.post('/inventory/transfer', { itemId, recipientId });
};
export const sellInventoryItem = (itemId) => {
  return apiClient.post('/inventory/sell', { itemId });
};

// --- Функции для Администрирования Беттинга ---

export const getTournaments = () => {
  return apiClient.get('/betting/tournaments');
};

export const createTournament = (data) => {
  // data = { name, pageUrl, logoUrl, startDate, endDate }
  return apiClient.post('/betting/tournaments', data);
};
export const getPickemData = (tournamentId) => {
  return apiClient.get(`/betting/tournaments/${tournamentId}/pickem`);
};

export const savePickemPicks = (tournamentId, picks) => {
  return apiClient.post(`/betting/tournaments/${tournamentId}/pickem`, { picks });
};

export const deleteTournament = (tournamentId) => {
  return apiClient.delete(`/betting/tournaments/${tournamentId}`);
};

export const getTeams = () => {
  return apiClient.get('/betting/teams');
};

export const createTeam = (data) => {
  // data = { name, profileUrl, logoUrl }
  return apiClient.post('/betting/teams', data);
};

export const deleteTeam = (teamId) => {
  return apiClient.delete(`/betting/teams/${teamId}`);
};

export const getMatchesForTournament = (tournamentId) => {
  return apiClient.get(`/betting/tournaments/${tournamentId}/matches`);
};

export const createMatch = (data) => {
  return apiClient.post('/betting/matches', data);
};

export const updateMatchOdds = (matchId, data) => {
  return apiClient.patch(`/betting/matches/${matchId}/odds`, data);
};

export const resolveMatch = (matchId, winnerId) => {
  return apiClient.post(`/betting/matches/${matchId}/resolve`, { winnerId });
};

export const deleteMatch = (matchId) => {
  return apiClient.delete(`/betting/matches/${matchId}`);
};

// --- Функции для Игроков (Беттинг) ---
export const getActiveMatches = () => {
  return apiClient.get('/betting/active-matches');
};

export const getSyncStatus = () => {
  return apiClient.get('/betting/sync/public-status');
};

export const placeBet = (data) => {
  // data = { matchId, teamId, amount }
  return apiClient.post('/betting/bets', data);
};
export const updateMatch = (matchId, data) => {
  // data = { startTime, odds1, odds2, matchUrl }
  return apiClient.patch(`/betting/matches/${matchId}`, data);
};

export const createEvent = (data) => {
  // data = { matchId, name, option1, option2, odds1, odds2 }
  return apiClient.post('/betting/events', data);
};

export const deleteEvent = (eventId) => {
  return apiClient.delete(`/betting/events/${eventId}`);
};

export const resolveEvent = (eventId, winner) => {
  // winner: 1 или 2
  return apiClient.post(`/betting/events/${eventId}/resolve`, { winner });
};

// --- Ставки на Доп. События (Клиент) ---
export const placeEventBet = (data) => {
  // data = { eventId, choice, amount }
  return apiClient.post('/betting/events/bet', data);
};
export const toggleEventLock = (eventId) => {
  return apiClient.post(`/betting/events/${eventId}/toggle-lock`);
};

export const updateBotStatus = (data) => {
  // data = { type, text, status }
  return apiClient.post('/admin/bot-status', data);
};

export const cancelMatchBet = (matchId) => {
  return apiClient.delete('/betting/bets/match', { data: { matchId } });
};

export const cancelEventBet = (eventId) => {
  return apiClient.delete('/betting/bets/event', { data: { eventId } });
};
export const generateSSOCode = (token) => {
  console.log('SSO: Инициирован обмен кода для токена:', token.substring(0, 10) + '...');
  
  // Мы используем НОВЫЙ, чистый экземпляр axios, 
  // чтобы глобальные перехватчики не вмешались
  return axios.post('/api/sso/generate', {}, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};
export const getRawHistoryForStats = () => apiClient.get('/me/stats-raw');
// --- Функции для Донатов ---

// Получение публичной информации о получателе (для страницы /donate/:id)
export const getDonationUserInfo = (userId) => {
  return apiClient.get(`/donations/user/${userId}`);
};

// Отправка доната
export const sendDonation = (data) => {
  // data = { receiverId, amount, message, isTts, isStreamContext }
  return apiClient.post('/donations/send', data);
};

// Обновление настроек доната текущего пользователя
export const updateDonationSettings = (data) => {
  // data = { enabled, minDonation, minTtsDonation }
  return apiClient.patch('/me/donation-settings', data);
};

export const toggleTournamentPickem = (tournamentId) => {
  return apiClient.patch(`/betting/tournaments/${tournamentId}/toggle-pickem`);
};

export const toggleTournamentSync = (tournamentId) => {
  return apiClient.patch(`/betting/tournaments/${tournamentId}/toggle-sync`);
};

export const getQuests = () => apiClient.get('/quests');
export const claimQuestReward = (questId) => apiClient.post(`/quests/${questId}/claim`);

export const getAdminStats = (type = 'all') => {
  return apiClient.get('/admin/stats', { params: { type } });
};